const colors = {
black0: '#C1C2C5',
black1: '#A6A7AB',
black2: '#909296',
black3: '#5C5F66',
black4: '#373A40',
black5: '#2C2E33',
black6: '#25262B',
black7: '#1A1B1E',
black8: '#141517',
black9: '#101113',

gray0: '#F8F9FA',
gray1: '#F1F3F5',
gray2: '#E9ECEF',
gray3: '#DEE2E6',
gray4: '#CED4DA',
gray5: '#ADB5BD',
gray6: '#868E96',
gray7: '#495057',
gray8: '#343A40',
gray9: '#212529',

red0: '#FFF5F5',
red1: '#FFE3E3',
red2: '#FFC9C9',
red3: '#FFA8A8',
red4: '#FF8787',
red5: '#FF6B6B',
red6: '#FA5252',
red7: '#F03E3E',
red8: '#E03131',
red9: '#C92A2A',

pink0: '#FFF0F6',
pink1: '#FFDEEB',
pink2: '#FCC2D7',
pink3: '#FAA2C1',
pink4: '#F783AC',
pink5: '#F06595',
pink6: '#E64980',
pink7: '#D6336C',
pink8: '#C2255C',
pink9: '#A61E4D',

grape0:'#F8F0FC',
grape1:'#F3D9FA',
grape2:'#EEBEFA',
grape3:'#E599F7',
grape4:'#DA77F2',
grape5:'#CC5DE8',
grape6:'#BE4BDB',
grape7:'#AE3EC9',
grape8:'#9C36B5',
grape9:'#862E9C',

violet0:'#F3F0FF',
violet1:'#E5DBFF',
violet2:'#D0BFFF',
violet3:'#B197FC',
violet4:'#9775FA',
violet5:'#845EF7',
violet6:'#7950F2',
violet7:'#7048E8',
violet8:'#6741D9',
violet9:'#5F3DC4',

indigo0:'#EDF2FF',
indigo1:'#DBE4FF',
indigo2:'#BAC8FF',
indigo3:'#91A7FF',
indigo4:'#748FFC',
indigo5:'#5C7CFA',
indigo6:'#4C6EF5',
indigo7:'#4263EB',
indigo8:'#3B5BDB',
indigo9:'#364FC7',

blue0: '#E7F5FF',
blue1: '#D0EBFF',
blue2: '#A5D8FF',
blue3: '#74C0FC',
blue4: '#4DABF7',
blue5: '#339AF0',
blue6: '#228BE6',
blue7: '#1C7ED6',
blue8: '#1971C2',
blue9: '#1864AB',

cyan0: '#E3FAFC',
cyan1: '#C5F6FA',
cyan2: '#99E9F2',
cyan3: '#66D9E8',
cyan4: '#3BC9DB',
cyan5: '#22B8CF',
cyan6: '#15AABF',
cyan7: '#1098AD',
cyan8: '#0C8599',
cyan9: '#0B7285',

teal0: '#E6FCF5',
teal1: '#C3FAE8',
teal2: '#96F2D7',
teal3: '#63E6BE',
teal4: '#38D9A9',
teal5: '#20C997',
teal6: '#12B886',
teal7: '#0CA678',
teal8: '#099268',
teal9: '#087F5B',

green0:'#EBFBEE',
green1:'#D3F9D8',
green2:'#B2F2BB',
green3:'#8CE99A',
green4:'#69DB7C',
green5:'#51CF66',
green6:'#40C057',
green7:'#37B24D',
green8:'#2F9E44',
green9:'#2B8A3E',

lime0: '#F4FCE3',
lime1: '#E9FAC8',
lime2: '#D8F5A2',
lime3: '#C0EB75',
lime4: '#A9E34B',
lime5: '#94D82D',
lime6: '#82C91E',
lime7: '#74B816',
lime8: '#66A80F',
lime9: '#5C940D',

yellow0:'#FFF9DB',
yellow1:'#FFF3BF',
yellow2:'#FFEC99',
yellow3:'#FFE066',
yellow4:'#FFD43B',
yellow5:'#FCC419',
yellow6:'#FAB005',
yellow7:'#F59F00',
yellow8:'#F08C00',
yellow9:'#E67700',

orange0:'#FFF4E6',
orange1:'#FFE8CC',
orange2:'#FFD8A8',
orange3:'#FFC078',
orange4:'#FFA94D',
orange5:'#FF922B',
orange6:'#FD7E14',
orange7:'#F76707',
orange8:'#E8590C',
orange9:'#D9480F',
}
export default colors